import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';


class ApplicantLogin {

  
    GetRegesterdData(ApplicantID){
                
        return axios.post(API_URL + `Security/GetRegesterdUserData?ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
        
     }
     GetNationalityList(){
        return axios.get(API_URL + 'Lookup/GetNationalitySelectAll')
        }
      GetGendelList(){
        
            return axios.get(API_URL + 'Lookup/GetGenderSelectAll')
     }
     GetReligionList(){
        return axios.get(API_URL + 'Lookup/GetReligionsSelectAll')

     }
     GetGovernorate(CountryID){
      return axios.get(API_URL + `Lookup/GetGovernorate?CountryId=${CountryID}`,{
        
      },
      { headers: authHeader() })
     }
     GetCountriesSelectAll(){
      return axios.get(API_URL + 'Lookup/GetCountriesSelectAll',{
        
      },
      { headers: authHeader() })
     }
     // New
    GetApplicant_HowYouKnowUs(ApplicantID){
      return axios.get(API_URL + `ApplicantData/GetApplicant_HowYouKnowUs?ApplicantID=${ApplicantID}`,{

      },
      { headers: authHeader() } )
    }

    GetHowYouKnowUs_Options(){
      return axios.get(API_URL + `ApplicantData/GetHowYouKnowUs_Options`,{

      },
      { headers: authHeader() } )
    }

    PostApplicantHowYouKnowUs(ApplicantID,OptionID,Note){
      return axios.post(API_URL + `ApplicantData/PostApplicantHowYouKnowUs?ApplicantID=${ApplicantID}&OptionID=${OptionID}&Note=${Note}`,{

      },
      { headers: authHeader() } )
    }
    // End
     CertificationTypeSelectAll(){
      return axios.get(API_URL + 'Lookup/CertificationTypeSelectAll',{
        
      },
      { headers: authHeader() })
     }
     GetCertificationYears(){
      return axios.get(API_URL + 'Lookup/GetCertificationYears',{
        
      },
      { headers: authHeader() })
     }
     GetCertificationSpecialization(CertificateID){
      return axios.get(API_URL + `Lookup/SpecializationType_SelectByID?CertificateType=${CertificateID}`,{
        
      },
      { headers: authHeader() })

     }
     GetBranchesAPI(){
      return axios.get(API_URL + `Lookup/GetBranchesAPI`,{
        
      },
      { headers: authHeader() } )
    }
    GetFacultyBranchesAPI(BranchID){
      return axios.get(API_URL + `Lookup/FacultyByBranchAPI?BranchId=${BranchID}`,{
        
      },
      { headers: authHeader() } )
      }
    GetActiveFacultyBranchesAPI(BranchID){
      return axios.get(API_URL + `Lookup/FacultyActiveByBranchAPI?BranchId=${BranchID}`,{
        
      },
      { headers: authHeader() } )
      }
    GetEnrollmentStatus(){
      return axios.get(API_URL + `Lookup/GetEnrollmentStatus`,{
        
      },
      { headers: authHeader() } )
      }
    GetlistOfPreferences(){
      return axios.get(API_URL + `ApplicantData/GetlistOfPreferences`,{
        
      },
      { headers: authHeader() } )
      }
      GetActiveAvailableSemester(){
      return axios.get(API_URL + `Lookup/GetActiveAvailableSemester`,{
        
      },
      { headers: authHeader() } )
      }
      GetAttachmentTypes(){
      return axios.get(API_URL + `FileAttachments/FileAttachmentsTypes_SelectAll`,{
        
      },
      { headers: authHeader() } )
      }
      GetAllExamTypes(){
      return axios.get(API_URL + `Exams/GetAllExamTypes`,{
        
      },
      { headers: authHeader() } )
      }
      GetChangeAllExamTypes(){
      return axios.get(API_URL + `Exams/GetAllExamTypesToChange`,{
        
      },
      { headers: authHeader() } )
      }
      GetAllEquivalentExamTypes(){
      return axios.get(API_URL + `Exams/GetAllEquivalentExamTypes`,{
        
      },
      { headers: authHeader() } )
      }
      GetAllCertificationFileAttachment(){
      return axios.get(API_URL + `Exams/GetAllCertificationFileAttachment`,{
        
      },
      { headers: authHeader() } )
      }
      PostExamDatesLocationsAPI(ExamID,ApplicantExamID){
      return axios.get(API_URL + `Exams/PostExamDatesLocationsAPI?ExamID=${ExamID}&ApplicantExamID=${ApplicantExamID}`,{
        
      },
      { headers: authHeader() } )
      }
      GetTermsandConditions(){
        return axios.get(API_URL + `TermsAndCondition/GetCurrentTermAndCondition`,{
        
        },
        { headers: authHeader() } )
      }
      GetHelpPages(PageID){
        return axios.get(API_URL + `HelpPages/SelectHelpPageAndSection?PageId=${PageID}`,{
        
        },
        { headers: authHeader() })
      }

     
      GetQualificationExams(ApplicantID){
        return axios.get(API_URL + `Exams/GetQualificationExams?ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }

      GetDownloadPaymentPdf(ApplicantID){
        return axios.get(API_URL + `PaymentOrder/DownloadPaymentPdf?ApplicantID=${ApplicantID}`,{
          responseType : "blob"
        },
        { headers: authHeader() })
      }

      UpdateUploadEquivalentExamFile(ApplicantExamID, ApplicantID){
        return axios.post(API_URL + `Exams/UpdateWillUploadEquivalentExamFile?ApplicantExamID=${ApplicantExamID}&ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }
      MinistryInquiry(ApplicantID){
        return axios.get(API_URL + `MinistryAPI/MinistryInquiry?ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }
      AcceptMinistryAPI(ApplicantID,ApplicationId){
        return axios.post(API_URL + `MinistryAPI/AcceptMinistryAPI?ApplicationID=${ApplicationId}&ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }

      PostPaymentOrder(ApplicantID,ApplicationId){
        return axios.post(API_URL + `BankMasr_MPGS/PostPaymentOrder?ApplicantSerial=${ApplicantID}&ApplicationId=${ApplicationId}`,{
        
        },
        { headers: authHeader() })
      }

      GetUnpaidPaymentOrderDetails(ApplicantID){
        return axios.get(API_URL + `BankMasr_MPGS/GetUnpaidPaymentOrderDetailsByApplicantId?ApplicantId=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }

      GetBankSessionAsync(){
        return axios.post(API_URL + `BankMasr_MPGS/BankSessionAsync`,{
        
        },
        { headers: authHeader() })
      }

}

export default new ApplicantLogin();
